import moment from "moment";

import templateUrl from './assigned-events-calendar-container.component.html';
import { TimeSlotDecorator } from "../time-slot-decorator.service";
import { ScheduleEventAssignedStatus, IcdOfficeService, EmployeeService, EventHostService, ScheduleEventService, ScheduleEventTimeSlotService, DivisionService } from "../../../core/services/data-services";
import { SiteModuleEnum } from "../../../core/enum/site-module";
import { ScheduleEventDetailModal } from '../shared/schedule-event-detail.component';
import { IQService, noop } from "angular";
import { StateService } from "angular-ui-router";
import { UtilityService } from "../../../core/services/utility.service";

// eslint-disable-next-line @typescript-eslint/naming-convention
const AssignedStatus = {
    Pending: "Pending",
    Accepted: "Accepted",
    Rejected: "Rejected",
    Unassigned: "Unassigned"
};

export const AssignedEventsCalendarContainerComponent = {
    templateUrl,
    bindings: {
        calendar: "<",
        divisionID: "<",
        icdOfficeID: "<"
    },
    controller: class AssignedEventsCalendarContainerController {
        startDate: Date;
        endDate: Date;
        divisionID: number;
        icdOfficeID: number;
        timeSlotDecorator: TimeSlotDecorator;
        //TODO: Add type definitions.
        scheduleActions: any;
        calendar: any;
        filters: any;
        employeeOptions: any;
        icdOffice: any;
        icdOffices: any[];
        division: any;
        divisions: any[];
        eventHosts: any[];
        scheduleEvents: any[];
        dropdownOptions;

        constructor(private $q: IQService, private $state: StateService, private $uibModal,
            private divisionService: DivisionService, private employeeService: EmployeeService,
            private eventHostService: EventHostService, private icdOfficeService: IcdOfficeService,
            private scheduleEventService: ScheduleEventService,
            private scheduleEventTimeSlotService: ScheduleEventTimeSlotService,
            private utilityService: UtilityService) {
            'ngInject';

            this.timeSlotDecorator = new TimeSlotDecorator({
                warnAboutUnassigned: true
            });
            this.scheduleActions = this.createScheduleActions();
            this.dropdownOptions = {
                dataSource: new kendo.data.DataSource({
                    data: this.icdOffices,
                }),
                headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
                open: () => {
                    setTimeout(() => {
                        const widget = $("#icdOfficeFilter").data("kendoDropDownList");
                        const source = this.icdOffices;
                        $("#allcorps").off("click").on("click", (e) => {
                            const isChecked = $(e.target).prop("checked");

                            const filtered = isChecked
                                ? source.filter(c => c.Inactive === false)
                                : source;
                            widget.dataSource.data(filtered);
                            widget.refresh();
                            widget.popup.open(); // keep it open after refresh
                        });
                    }, 0);
                }
            }
        }

        $onInit() {
            this.filters = {};
            this.employeeOptions = this.createEmployeeOptions();

            const divisionsLoaded =
                this.loadDivisions()
                    .then(() => this.loadIcdOffices())
                    .then(offices => {
                        if (offices.length === 1) {
                            this.icdOffice = offices[0];
                        } else if (this.icdOfficeID) {
                            this.icdOffice = offices.find(p => p.Id === this.icdOfficeID);
                        }
                    })

            // Load event hosts list passively anytime after the divisions list has loaded.
            divisionsLoaded.then(() => this.loadEventHosts());

            const scheduleEvents = divisionsLoaded.then(() => {
                return this.loadScheduleEvents();
            });

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(scheduleEvents, "Initial load failed")
            )
        }

        $onChanges() {
        }

        onChangeDivision() {
            const loaded = this.loadIcdOffices()
                .then(() => this.loadEventHosts());
            this.$state.go(".", { divisionID: this.division ? this.division.Id : null });
            this.utilityService.showLoadingUntilResolved(
                loaded
            );
        }

        onChangeIcdOffice() {
            const scheduleEventLoaded = this.loadScheduleEvents();
            this.$state.go(".", { icdOfficeID: this.icdOffice ? this.icdOffice.Id : null });
            this.utilityService.showLoadingUntilResolved(
                scheduleEventLoaded
            );
        }

        onChangeCalendar(calendar) {
            this.calendar.startDate = calendar.startDate;
            this.calendar.endDate = calendar.endDate;
            this.calendar.mode = calendar.mode;
            this.$state.go(".", { ...this.calendar })
            this.utilityService.showLoadingUntilResolved(
                this.loadScheduleEvents()
            )
        }

        onChangeFilters() {
            this.utilityService.showLoadingUntilResolved(
                this.loadScheduleEvents()
            )
        }

        onRespond({ scheduleEvent, response }) {
            const responded = this.scheduleEventService.patchScheduleEvent(scheduleEvent.id, {
                ChangeIcdOfficeAcceptance: {
                    AssignedStatus: response,
                    IcdOfficeID: this.icdOffice.Id
                }
            });

            responded.then(() => {
                return this.scheduleEventService.retrieveScheduleEvent(scheduleEvent.id)
            }).then(() => {
                return this.loadScheduleEvents();
            });

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(responded, "Response failed")
            );
        }

        loadIcdOffices() {
            let request;
            if (this.division && this.division.Id) {
                request = this.icdOfficeService.retrieveIcdOffices({
                    divisionID: this.division.Id,
                    moduleID: SiteModuleEnum.EventsScheduling
                })
            } else {
                request = this.icdOfficeService.retrieveIcdOffices({
                    moduleID: SiteModuleEnum.EventsScheduling
                });
            }
            return request
                .then(offices =>
                    this.icdOffices = offices.map(office => ({
                        Id: office.Id,
                        IcdCorporationID: office.IcdCorporationID,
                        Name: `${office.OwnerName} - ${office.OfficeName}`
                    })).sort((a, b) => a.Name.toLowerCase() < b.Name.toLowerCase() ? -1 : 1));
        }

        loadDivisions() {
            return this.divisionService.retrieveDivisions({
                ModuleID: SiteModuleEnum.EventsScheduling
            }).then(p => this.divisions = p.sort((a, b) => a.Name < b.Name ? -1 : 1))
                .then(divisions => {
                    if (divisions.length === 1) {
                        this.division = divisions[0];
                    } else if (this.divisionID) {
                        this.division = divisions.find(p => p.Id === this.divisionID);
                    }
                });
        }

        loadEventHosts() {
            if (!this.division) {
                return this.$q.resolve([]);
            }
            return this.eventHostService.retrieveEventHosts({
                divisionID: this.division.Id
            }).then(eventHosts => this.eventHosts = eventHosts.map(p => ({
                ...p,
                Text: `${p.HostName} - ${p.HostLocationName}`
            })));
        }

        loadScheduleEvents() {
            if (!this.icdOffice) {
                return this.$q.resolve([]);
            }
            return this.scheduleEventTimeSlotService
                .retrieveOfficeScheduleEventTimeSlots(this.icdOffice.Id, {
                    StartDate: this.calendar.startDate,
                    EndDate: this.calendar.endDate,
                    AssignedStatus: this.filters.assignedStatus,
                    EventHostID: this.filters.eventHost ? this.filters.eventHost.EventHostID : null,
                    IsAssigned: this.filters.isAssigned,
                    AssignedEmployees: this.filters.employees && this.filters.employees.length ?
                        this.filters.employees.map(p => p.Value) : null
                })
                .then(groupTimeSlotsByScheduleEvent)
                .then(scheduleEvents => scheduleEvents.filter(notRejected))
                .then(scheduleEvents => scheduleEvents.map(p => this.mapScheduleEventsToVM(p)))
                .then(scheduleEvents => this.scheduleEvents = scheduleEvents);
        }

        mapScheduleEventsToVM(scheduleEvent) {
            const eventNames = [
                scheduleEvent.HostLocationName
                    ? `${scheduleEvent.HostName} (${scheduleEvent.HostLocationName})`
                    : scheduleEvent.HostName,
                scheduleEvent.Program
            ].filter(p => p && p.trim())
                .join(" - ");

            const accepted = scheduleEvent.ScheduleEventOffices.reduce((any, office) =>
                any || office.IcdOfficeID === this.icdOffice.Id
                && office.AssignedStatus === AssignedStatus.Accepted, false);

            return {
                id: scheduleEvent.ScheduleEventID,
                name: eventNames,
                description: `${moment(scheduleEvent.StartDate).format("MMM DD")}–`
                    + `${moment(scheduleEvent.EndDate).format("MMM DD")}`
                    + (accepted ? ` (accepted)`
                        : " (pending acceptance)"),
                readOnly: true,
                timeSlots: scheduleEvent.TimeSlots.map(timeSlot => ({
                    id: timeSlot.TimeSlotAssignmentID,
                    startDateTime: timeSlot.StartDateTime,
                    endDateTime: timeSlot.EndDateTime,
                    description: timeSlot.Employee
                        ? `${timeSlot.Employee.FirstName} ${timeSlot.Employee.LastName}`
                        : "Unassigned",
                    draggable: false,
                    style: {
                        ...this.timeSlotDecorator.decorateTimeSlotColor(timeSlot)
                    }
                })),
                AssignedStatus: scheduleEvent.AssignedStatus
            };
        }

        createEmployeeOptions() {
            return {
                dataSource: {
                    transport: {
                        read: e => this.employeeDataSourceRead(e)
                    },
                    serverFiltering: true,
                },
                dataTextField: 'Text',
                dataValueField: 'Value'
            };
        }

        employeeDataSourceRead(e) {
            const preselected = this.filters.employees || [];

            if (!this.icdOffice) {
                e.success(preselected);
                return;
            }

            const filter = e.data.filter;
            const searchFilter = filter ? filter.filters[0] : null;
            const searchValue = searchFilter ? searchFilter.value : "";

            let employees;
            const query = {
                FullName: searchValue,
                IcdOfficeID: this.icdOffice.Id,
                PageSize: searchValue.length < 3 ? 10 : null
            };
            if (searchValue.length < 3) {
                employees = this.employeeService.retrieveEmployeesPage(0, query)
                    .then(page => page.Entities);
            } else {
                employees = this.employeeService.retrieveEmployees(query);
            }

            return employees.then(employees => employees.map(employee => ({
                Value: employee.Id,
                Text: `${employee.FirstName} ${employee.LastName}`
            }))
                .filter(p => !preselected.find(q => q.Value === p.Value)))
                .then(employees => {
                    e.success(preselected.concat(employees));
                })
                .catch(ex => e.error(ex));
        }

        onViewDetails(scheduleEvent) {
            const detail = this.scheduleEventService.retrieveScheduleEvent(scheduleEvent.id)
                .then(detail => {
                    // Hydrate with schedule event details
                    return this.hydrateScheduleEvent(detail);
                });

            this.utilityService.showLoadingUntilResolved(detail);

            this.$uibModal.open({
                ...ScheduleEventDetailModal,
                resolve: {
                    scheduleEvent: detail
                }
            }).result.catch(noop);
        }

        hydrateScheduleEvent(detail) {
            const eventHostLoaded = this.eventHostService.retrieveEventHost(detail.EventHostID)
                .then(eventHost => detail.EventHost = eventHost);

            return this.$q.all([eventHostLoaded])
                .then(() => detail);
        }

        createScheduleActions() {
            return [{
                label: () => "Accept",
                enabled: schedule => schedule.AssignedStatus === ScheduleEventAssignedStatus.Pending,
                action: schedule => this.onRespond({
                    scheduleEvent: schedule,
                    response: ScheduleEventAssignedStatus.Accepted
                })
            },
            {
                label: () => "Reject",
                enabled: schedule => schedule.AssignedStatus === ScheduleEventAssignedStatus.Pending,
                action: schedule => this.onRespond({
                    scheduleEvent: schedule,
                    response: ScheduleEventAssignedStatus.Rejected
                })
            },
            {
                label: () => "Undo",
                enabled: schedule => schedule.responded,
                action: schedule => this.onRespond({
                    scheduleEvent: schedule,
                    response: ScheduleEventAssignedStatus.Pending
                })
            },
            {
                label: () => "Event Details",
                enabled: () => true,
                action: schedule => this.onViewDetails(schedule)
            }];
        }
    }
};

function groupTimeSlotsByScheduleEvent(timeSlots) {
    return timeSlots.reduce((ag, timeSlot) => {
        let scheduleEvent = ag.dict[timeSlot.ScheduleEvent.ScheduleEventID];
        if (!scheduleEvent) {
            scheduleEvent = {
                ...timeSlot.ScheduleEvent,
                TimeSlots: []
            };
            ag.dict[scheduleEvent.ScheduleEventID] = scheduleEvent;
            ag.events.push(scheduleEvent);
        }

        // Clone the time slot, but remove the schedule event property.
        scheduleEvent.TimeSlots.push({
            StartDateTime: timeSlot.StartDateTime,
            EndDateTime: timeSlot.EndDateTime,
            Employee: timeSlot.Employee
        });

        return ag;
    }, { events: [], dict: {} }).events;
}

function notRejected(scheduleEvent) {
    return scheduleEvent.AssignedStatus !== ScheduleEventAssignedStatus.Rejected;
}

